import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

import { TextModule } from '@shared/components/text/text.module';
import { TooltipModule } from '@shared/components/tooltip';

import { FormModule } from '../form/form.module';
import { FormRelativeTimeInputComponent } from './form-relative-time-input.component';

@NgModule({
  imports: [
    // Minga Dependencies
    CommonModule,
    TooltipModule,
    FormModule,

    // External Dependencies
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    TextModule,
  ],
  exports: [FormRelativeTimeInputComponent],
  declarations: [FormRelativeTimeInputComponent],
})
export class FormRelativeTimeInputModule {}
